import styled from 'styled-components';
import { Dialog as MuiDialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import Icons from '../Icons';

export const Dialog = styled(MuiDialog)`
  .MuiDialog-container {
    .MuiDialog-paper {
      ${({ $fullScreen }) => $fullScreen && 'margin: 0;'};
      background-color: ${({ $isTransparent }) =>
        $isTransparent ? 'var(--mainModalBgColor)' : 'var(--main-modal-opaque-bg)'};
      backdrop-filter: ${({ $isTransparent }) => ($isTransparent ? 'var(--mainModalBackDrop)' : 'var(--richBlack2)')};
      width: ${({ $fullScreen, $size }) => ($fullScreen ? '100%' : $size?.width)};
      height: ${({ $fullScreen, $size }) => ($fullScreen ? '100%' : $size?.height)};
      max-width: 100vw;
      max-height: 100vh;
      min-width: ${({ $size, $fullScreen }) => !$fullScreen && !$size?.width && '400px'};
      min-height: ${({ $size, $fullScreen }) => !$fullScreen && !$size?.height && '250px'};
      border-radius: ${({ $fullScreen }) => ($fullScreen ? '0' : 'var(--main-modal-radius)')};
      box-sizing: content-box;
      transition: width 0.3s ease-in-out, height 0.3s ease-in-out, border-radius 0.3s ease-in-out;
    }
  }
  .MuiTypography-root {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .text {
      font-size: 16px;
      color: var(--darkJungleGreen);

      &.status {
        font-size: 22px;
        font-weight: bold;
        text-transform: capitalize;
      }
    }
  }

  .MuiBackdrop-root {
    background: var(--modal-backdrop-bg, var(--roofGreen-600));
    backdrop-filter: blur(5px);
  }
`;

export const Title = styled(DialogTitle)`
  &&& {
    letter-spacing: 0.5px;
    text-transform: var(--title-text-transform);
    font-size: 16px;
    color: var(--mainModalTitleColor);
    /* backdrop-filter: blur(12.5px); */
    background-color: ${({ $isTransparent }) =>
      $isTransparent ? 'var(--mainModalHeaderBgColor)' : 'var(--main-modal-opaque-band-bg)'};
    border-bottom: var(--mainModalBorder);
    height: var(--mainModalHeaderHeight);
    font-weight: 600;
    padding: var(--mainModalHeaderPadding);
    display: flex;
  }
`;

export const TitleText = styled.div`
  flex-grow: 1;
`;

export const ControlsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const CloseIcon = styled(Icons.Close)`
  cursor: pointer;
`;

export const MinimizeIcon = styled(Icons.Minimize)`
  cursor: pointer;
`;

export const Content = styled(DialogContent)`
  &&& {
    display: flex;
    flex-direction: column;
    position: relative;
    ${({ $fullScreen, $enableFullScreen }) =>
      $enableFullScreen ? ($fullScreen ? 'height: 100%;' : 'height: 68vh;') : ''};
    /* 'safe' falls back to start when content overflows, so the top stays scrollable instead of
       spilling under the header. */
    justify-content: ${({ $centralize }) => $centralize && 'safe center'};
    flex-grow: 1;
    padding: 20px 40px;
    background: var(--mainModalContentColor);
  }
`;

export const Message = styled.span`
  font-size: 14px;
  letter-spacing: 0.5px;
  color: var(--mainModalContentFontColor);
  font-weight: 400;
  text-align: center;
  white-space: pre-wrap;
`;

export const AdditionalControlsWrapper = styled.div`
  flex-grow: 1;
`;

export const Actions = styled(DialogActions)`
  &&& {
    justify-content: center;
    align-items: center;
    display: flex;
    background-color: ${({ $isTransparent }) =>
      $isTransparent ? 'var(--mainModalActionsBgColor)' : 'var(--main-modal-opaque-band-bg)'};
    border-top: var(--mainModalBorder);
    height: var(--mainModalActionsHeight);
    padding: var(--mainModalActionsPadding);
  }
`;
